import React from 'react';

import IconType from '../../../types/Icon';

const SpinnerColorDots: React.FC<IconType> = ({ color = 'currentColor', size = 100 }) => {
	return (
		<svg
			style={{ margin: 'auto', background: 'none', display: 'block', shapeRendering: 'auto' }}
			width={size}
			height={size}
			viewBox="0 0 100 100"
			preserveAspectRatio="xMidYMid">
			<g>
				<circle cx="69.04" cy="64.61" fill="#fc4309" r="3">
					<animateTransform
						attributeName="transform"
						type="rotate"
						calcMode="spline"
						values="0 50 50;360 50 50"
						keySplines="0.5 0 0.5 1"
						repeatCount="indefinite"
						dur="1.4925373134328357s"
						begin="0s"
					/>
				</circle>
				<circle cx="64.61" cy="69.04" fill="#ff765c" r="3">
					<animateTransform
						attributeName="transform"
						type="rotate"
						calcMode="spline"
						values="0 50 50;360 50 50"
						keySplines="0.5 0 0.5 1"
						repeatCount="indefinite"
						dur="1.4925373134328357s"
						begin="-0.062s"
					/>
				</circle>
				<circle cx="59.184" cy="72.173" fill="#ffb646" r="3">
					<animateTransform
						attributeName="transform"
						type="rotate"
						calcMode="spline"
						values="0 50 50;360 50 50"
						keySplines="0.5 0 0.5 1"
						repeatCount="indefinite"
						dur="1.4925373134328357s"
						begin="-0.125s"
					/>
				</circle>
				<circle cx="53.133" cy="73.795" fill="#ff9900" r="3">
					<animateTransform
						attributeName="transform"
						type="rotate"
						calcMode="spline"
						values="0 50 50;360 50 50"
						keySplines="0.5 0 0.5 1"
						repeatCount="indefinite"
						dur="1.4925373134328357s"
						begin="-0.187s"
					/>
				</circle>
				<circle cx="46.867" cy="73.795" fill="#ff6600" r="3">
					<animateTransform
						attributeName="transform"
						type="rotate"
						calcMode="spline"
						values="0 50 50;360 50 50"
						keySplines="0.5 0 0.5 1"
						repeatCount="indefinite"
						dur="1.4925373134328357s"
						begin="-0.25s"
					/>
				</circle>
				<circle cx="40.816" cy="72.173" fill="#fc4309" r="3">
					<animateTransform
						attributeName="transform"
						type="rotate"
						calcMode="spline"
						values="0 50 50;360 50 50"
						keySplines="0.5 0 0.5 1"
						repeatCount="indefinite"
						dur="1.4925373134328357s"
						begin="-0.312s"
					/>
				</circle>
				<circle cx="35.39" cy="69.04" fill="#ff765c" r="3">
					<animateTransform
						attributeName="transform"
						type="rotate"
						calcMode="spline"
						values="0 50 50;360 50 50"
						keySplines="0.5 0 0.5 1"
						repeatCount="indefinite"
						dur="1.4925373134328357s"
						begin="-0.375s"
					/>
				</circle>
				<circle cx="30.96" cy="64.61" fill="#ffb646" r="3">
					<animateTransform
						attributeName="transform"
						type="rotate"
						calcMode="spline"
						values="0 50 50;360 50 50"
						keySplines="0.5 0 0.5 1"
						repeatCount="indefinite"
						dur="1.4925373134328357s"
						begin="-0.437s"
					/>
				</circle>
				<animateTransform
					attributeName="transform"
					type="rotate"
					calcMode="spline"
					values="0 50 50;0 50 50"
					keySplines="0.5 0 0.5 1"
					repeatCount="indefinite"
					dur="1.4925373134328357s"
				/>
			</g>
		</svg>
	);
};

export default SpinnerColorDots;
